import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import utils from 'helpers/utils';
import StyledDealflowEntitiesViewBar
  from 'components/organisms/Bars/DealflowEntitiesViewBar/DealflowEntitiesViewBar.styles';
import {useAuthClient} from 'components/organisms/Providers/AuthProvider/AuthProvider';
import {useCollectionGet} from 'services/collection/collection.hooks';

const DealflowEntitiesViewBar = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'DealflowEntitiesViewBar');

  const client = useAuthClient();
  const universeCollection = useCollectionGet({collectionId: client?.universeCollectionId},
    {enabled: Boolean(client?.universeCollectionId)})?.data;

  innerProps.className = utils.flattenClassName(innerProps.className);

  return <StyledDealflowEntitiesViewBar ref={ref} {...innerProps} collection={universeCollection} />
});

DealflowEntitiesViewBar.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default DealflowEntitiesViewBar;
